module.exports = __webpack_public_path__ + "static/media/sc4.bf87ce93.jpg";